export type Visitor = {
  callFunction(functionName: string, args: any[]): void;
  getMember(leftPart: string, memberName: string): void;
};

export class ExpressionVisitor implements Visitor {
  public functionCalls: { functionName: string; args: any[] }[] = [];
  public getMembers: { leftPart: string; memberName: string }[] = [];

  callFunction(functionName: string, args: any[]): void {
    this.functionCalls.push({ functionName, args });
  }

  getMember(leftPart: string, memberName: string): void {
    this.getMembers.push({ leftPart, memberName });
  }
}
